import { Settings } from '@mui/icons-material';
import { Autocomplete, Box, Checkbox, FormControl, ListItemText, MenuItem, TextField } from '@mui/material';
interface ChipFieldProps {
  id: string;
  label: string;
  value?: any;
  options?: any;
  disabled?: boolean;
}

const ChipField = ({ options, id, disabled }: ChipFieldProps) => {
  return (
    <FormControl sx={{ width: '100%' }}>
      <Autocomplete<string, true, false, false>
        id={id}
        multiple
        limitTags={2}
        size="small"
        disabled={disabled ? disabled : false}
        options={options.map((type: any) => type.businesstype)}
        ListboxProps={{
          style: {
            maxHeight: '200px',
            overflow: 'auto',
            paddingBottom: '8px',
          },
        }}
        // onChange={(event, newValue) => {
        //   if (newValue.length === 0) {
        //     // Clear icon triggered
        //     console.log('Cleared all values');

        //     setState((prev) => ({
        //       ...prev,
        //       formone: {
        //         ...prev.formone,
        //         buisnessType: [],
        //       },
        //     }));
        //   }
        // }}
        // value={
        //   Array.isArray(state?.formone.buisnessType)
        //     ? state?.formone?.buisnessType.filter((type) =>
        //         businessTypes.some((business) => business?.businesstype === type)
        //       )
        //     : []
        // }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Business Type"
            variant="outlined"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          />
        )}
        // renderTags={(value, getTagProps) => (
        //   <>
        //     {state.formone.buisnessType.slice(0, 2).map((option, index) => (
        //       <Chip
        //         key={index + 1}
        //         label={option}
        //         {...getTagProps({ index })}
        //         onDelete={() => {
        //           // Remove the clicked chip from state
        //           setState((prev) => ({
        //             ...prev,
        //             formone: {
        //               ...prev.formone,
        //               buisnessType: prev.formone.buisnessType.filter((item) => item !== option),
        //             },
        //           }));
        //         }}
        //         style={{ maxWidth: '38%' }}
        //         sx={{
        //           maxWidth: '50px',
        //           textOverflow: 'ellipsis',
        //           overflow: 'hidden',
        //           whiteSpace: 'nowrap',
        //           fontSize: '11px',
        //           height: '25px',
        //           p: 0,
        //           '& .MuiChip-deleteIcon': {
        //             fontSize: '15px',
        //             p: 0,
        //           },
        //         }}
        //       />
        //     ))}
        //     {state.formone.buisnessType.length > 2 && (
        //       <Tooltip
        //         componentsProps={{
        //           tooltip: {
        //             sx: {
        //               backgroundColor: '#424242', // Set your desired background color here
        //             },
        //           },
        //           arrow: {
        //             sx: {
        //               color: '#424242', // Match arrow color with the background of the tooltip
        //             },
        //           },
        //         }}
        //         title={
        //           <List
        //             className="custom-scrollbar"
        //             sx={{
        //               padding: 1,
        //               overflowY: 'scroll',
        //               maxHeight: `${document.getElementById('businessTypes')?.getBoundingClientRect().bottom - 110}px`,
        //               '&::-webkit-scrollbar-track': {
        //                 background: '#424242',
        //               },
        //               '&::-webkit-scrollbar-thumb': {
        //                 border: '3px solid',
        //                 borderColor: '#424242',
        //               },
        //             }}
        //           >
        //             {state?.formone?.buisnessType
        //               .filter((type) => businessTypes.some((business) => business?.businesstype === type))
        //               .slice(2)
        //               .map((item, index) => (
        //                 <ListItem key={index} sx={{ padding: '4px 8px' }}>
        //                   {item}
        //                 </ListItem>
        //               ))}
        //           </List>
        //         }
        //         arrow
        //       >
        //         <Chip
        //           key={state.formone.buisnessType.length + 1}
        //           label={`+${value.length - 2}`}
        //           // {...getTagProps({ index: value.length })}
        //           onClick={(event) => {
        //             event.stopPropagation();
        //             event.preventDefault();
        //           }}
        //           sx={{
        //             height: '25px',
        //             cursor: 'default',
        //             pointerEvents: 'none',
        //             whiteSpace: 'pre-wrap',
        //           }}
        //         />
        //       </Tooltip>
        //     )}
        //   </>
        // )}
        renderOption={(props, option, { selected }) => {
          if (option === 'Add Business Type') {
            return (
              <Box
                sx={{
                  boxShadow: '0px -4px 10px -2px rgba(0, 0, 0, 0.2)',
                  width: '100%',
                  position: 'fixed',
                  bottom: '-20px',
                  zIndex: 1000,
                }}
              >
                <MenuItem
                  sx={{ whiteSpace: 'nowrap', m: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // open modal
                  }}
                >
                  <Settings fontSize="small" sx={{ mr: 1 }} />
                  <ListItemText primary="Add Business Type" />
                </MenuItem>
              </Box>
            );
          }

          return (
            <MenuItem
              {...props}
              key={JSON.stringify(option)} // ✔ UNIQUE because option object itself is unique
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Checkbox disableRipple checked={selected} />
              <ListItemText primary={option} />
            </MenuItem>
          );
        }}
      />
    </FormControl>
  );
};

export default ChipField;
